import { PlayerPhotos } from '@/entities';
import { MatchStatusEnum } from '@/domain/constants/constants';

export interface Session {
	email: string;
	uuid: string;
	token: string;
	expiration: string;
	isCompleted: boolean;
	isSuperAdmin: boolean;
	pbUuid: string;
	oltToken: string;
}

export interface SessionData {
	user?: Session;
}

export interface SessionV2 {
	uuid: string;
	email: string;
	token: string;
	pb_uuid: string;
	iat: number;
	exp: number;
}

export interface SearchMemberFilters {
	country?: string;
	country_id?: string;
	search?: string;
	age?: string;
	gender?: string;
	doubles_skill?: string;
	singles_skill?: string;
}

export interface TeamRecord {
	teamUuid: string;
	teamTitle: string;
	logo?: string;
}

export enum PlayerRole {
	TEAM_LEAGUE_TEAM_PLAYER = 'TEAM_LEAGUE_TEAM_PLAYER',
	TEAM_LEAGUE_TEAM_CAPTAIN = 'TEAM_LEAGUE_TEAM_CAPTAIN',
	TEAM_LEAGUE_TEAM_CAPTAIN_ASSISTANCE = 'TEAM_LEAGUE_TEAM_CAPTAIN_ASSISTANCE'
}

export interface TeamPlayerInfo {
	uuid: string;
	userUuid: string;
	photo: PlayerPhotos;
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	isInjured: boolean | null;
	balance: number;
	requests: string;
	countryId: number;
	stateId: number;
	localizationId: number;
	currencyId: string;
	lastSeason?: string | null;
	lastDivision?: string | null;
	dateDisabledOnTeam?: string | null;
	seasonTitle?: string | null;
	teamTitle?: string | null;
	dateDisabledOnTeamLeague: string | null;
	teamRecords: TeamRecord[];
	ratingDoubles: number;
	ratingSingles: number;
	gender: string;
	playerRole: PlayerRole;
	age: number;
	errorMessage: string | null;
	isPickleballUser: boolean;
	isNewPlayer: boolean;
}

export const ItemType = {
	PLAYER: 'player'
};

// TODO-tala: write naming similar to BE
export interface MatchScore {
	game1: string;
	game2: string;
	game3: string;
	game4: string;
	game5: string;
	final: string;
	gameOneStatus: string;
	gameTwoStatus: string;
	gameThreeStatus: string;
	gameFourStatus: string;
	gameFiveStatus: string;
	[key: string]: string | undefined;
}

export interface MatchScores {
	home: MatchScore;
	away: MatchScore;
	matchStatus?: MatchStatusEnum;
}

export interface ViewOption {
	value: string;
	label: string;
}

// TODO-tala: return to this
// interface HomeMatchScore {
// 	team_one_game_one_score: string;
// 	team_one_game_two_score: string;
// 	team_one_game_three_score: string;
// 	team_one_game_four_score: string;
// 	team_one_game_five_score: string;
// 	team_one_final_score: string;
// }

// interface AwayMatchScore {
// 	team_two_game_one_score: string;
// 	team_two_game_two_score: string;
// 	team_two_game_three_score: string;
// 	team_two_game_four_score: string;
// 	team_two_game_five_score: string;
// 	team_two_final_score: string;
// }
// export interface MatchScores {
// 	home: HomeMatchScore;
// 	away: AwayMatchScore;
// }
